import { useState } from "react";
import { usePhoneFactorProxy } from "../Custom Hooks/usePhoneFactorProxy";
import PhoneFactorTextMe from "../Components/PhoneFactorTextMe";
import PhoneFactorCallMe from "../Components/PhoneFactorCallMe";
import PhoneFactorMethodSelection from "../Components/PhoneFactorMethodSelection";
import { useVerifyRedirect } from "../Custom Hooks/useVerifyRedirect";
import { Typography } from "@sgi/gravity/Typography";
import ButtonLink from "../Components/ButtonLink";
import { Stack } from "@chakra-ui/react";

export default function PhoneFactor() {
  const [verificationCode, setVerificationCode] = useState("");
  const {
    sendCodeAction,
    callMeAction,
    verifyCodeAction,
    sendANewCodeAction,
    pageError,
    verificationCodeError,
    phoneNumber,
  } = usePhoneFactorProxy({verificationCode});

  const [selectedValue, setSelectedValue] = useState('');
  const lastTwoDigits = phoneNumber.length === 12 ? phoneNumber.slice(10) : '';

  const resetActionAct = useVerifyRedirect('resetMFA');

  if (selectedValue === '') {
    return <PhoneFactorMethodSelection
      pageError={pageError}
      setSelectedValue={setSelectedValue}
      lastTwoDigits={lastTwoDigits}
      sendCodeAction={sendCodeAction}
      callMeAction={callMeAction}
      verificationCodeError={verificationCodeError}
    >
      <Stack direction="row">
        <Typography variant="bodyBold" color="gray.800">
          Don't have access to methods above?
        </Typography>
        <ButtonLink
          linkCaption="Reset Access"
          handleClick={resetActionAct}
        />
        <input type="hidden" id="resetMfaSignal" value="false"/>
      </Stack>
    </PhoneFactorMethodSelection>;
  } else if (selectedValue === 'text') {
    return <PhoneFactorTextMe
      lastTwoDigits={lastTwoDigits}
      pageError={pageError}
      verificationCodeError={verificationCodeError}
      verificationCode={verificationCode}
      verifyCodeAction={verifyCodeAction}
      sendANewCodeAction={sendANewCodeAction}
      setVerificationCode={setVerificationCode}
    />;
  } else if (selectedValue === 'call') {
    return <PhoneFactorCallMe
      setSelectedValue={setSelectedValue}
      verificationCodeError={verificationCodeError}
      lastTwoDigits={lastTwoDigits}
    />;
  } else {
    return null;
  }
}
